"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var ExpandMore_1 = __importDefault(require("@mui/icons-material/ExpandMore"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var q_play_core_1 = require("@nordicscreen/q-play-core");
var react_i18next_1 = require("react-i18next");
var Integration_module_css_1 = __importDefault(require("../../Integration.module.css"));
var TypeGuards_1 = require("@/functions/TypeGuards");
var ResourceScriptAccordion = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _o = (0, react_1.useState)(), integrationResourceTemplate = _o[0], setIntegrationResourceTemplate = _o[1];
    (0, react_1.useEffect)(function () {
        var _a;
        if ((_a = props.resourceEditorData) === null || _a === void 0 ? void 0 : _a.template) {
            var resource = props.integrationTemplate.definition.script.scripts[props.resourceEditorData.template];
            setIntegrationResourceTemplate(resource !== null && resource !== void 0 ? resource : undefined);
        }
        else {
            setIntegrationResourceTemplate(undefined);
        }
    }, [(_a = props.resourceEditorData) === null || _a === void 0 ? void 0 : _a.template, props.integrationTemplate.definition.script.scripts]);
    var isEmptyResource = !((_b = props.resourceEditorData) === null || _b === void 0 ? void 0 : _b.template)
        && !((_c = props.resourceEditorData) === null || _c === void 0 ? void 0 : _c.name)
        && (!((_d = props.resourceEditorData) === null || _d === void 0 ? void 0 : _d.variables) || Object.keys(props.resourceEditorData.variables).length === 0);
    if (isEmptyResource) {
        return null;
    }
    var onIntegrationScriptChange = function (event) {
        if (!props.resourceEditorData)
            return;
        if (event.target.value !== "") {
            props.resourceEditorData.template = event.target.value;
            props.resourceEditorData.variables = {};
            var scriptTemplate = props.integrationTemplate.definition.script.scripts[props.resourceEditorData.template];
            scriptTemplate.settings.forEach(function (setting) {
                var defaultValue = setting.getDefaultValue();
                if ((0, TypeGuards_1.isPrimitive)(defaultValue)) {
                    props.resourceEditorData.variables[setting.key] = defaultValue;
                }
            });
        }
        else {
            props.resourceEditorData.template = undefined;
        }
        props.onScriptResourceChangedHandler(props.identifier, props.resourceEditorData);
    };
    var onScriptNameChange = function (event) {
        props.resourceEditorData.name = event.target.value;
        props.onScriptResourceChangedHandler(props.identifier, props.resourceEditorData);
    };
    var onScriptSettingsChangedHandler = function (e, key) {
        var data_value;
        var propKey;
        var setting;
        if (key) {
            propKey = key;
            setting = integrationResourceTemplate === null || integrationResourceTemplate === void 0 ? void 0 : integrationResourceTemplate.settings.find(function (setting) { return setting.key === propKey; });
            data_value = e;
        }
        else {
            var event_1 = e;
            propKey = event_1.target.dataset.key;
            setting = integrationResourceTemplate === null || integrationResourceTemplate === void 0 ? void 0 : integrationResourceTemplate.settings.find(function (setting) { return setting.key === propKey; });
            if (setting instanceof q_play_core_1.BooleanSetting) {
                data_value = event_1.target.checked;
            }
            else {
                data_value = event_1.target.value;
            }
        }
        if (setting) {
            switch (propKey) {
                case "size":
                    // eslint-disable-next-line no-case-declarations
                    var value = setting.hydrate(data_value);
                    props.resourceEditorData.variables[propKey] = value;
                    if ((props.resourceEditorData.variables[propKey] + "").includes("x")) {
                        var size = (props.resourceEditorData.variables[propKey] + "").split("x");
                        props.resourceEditorData.variables["width"] = parseInt(size[0]);
                        props.resourceEditorData.variables["height"] = parseInt(size[1]);
                    }
                    break;
                default:
                    if (setting instanceof q_play_core_1.BooleanSetting) {
                        props.resourceEditorData.variables[propKey] = data_value;
                    }
                    else {
                        // eslint-disable-next-line no-case-declarations
                        var value_1 = setting.hydrate(data_value);
                        props.resourceEditorData.variables[propKey] = value_1;
                    }
                    break;
            }
            props.onScriptResourceChangedHandler(props.identifier, props.resourceEditorData);
        }
    };
    var scriptName = new q_play_core_1.StringSetting("script-name", t("Name"));
    var scriptSelect = new q_play_core_1.SelectSetting("script-select", "Script");
    var options = [];
    options.push({ label: "Empty", value: "" });
    Object.keys(props.integrationTemplate.definition.script.scripts).map(function (key) {
        if (props.integrationTemplate.definition.script.scripts[key].schedule.type !== "live") {
            options.push({ label: props.integrationTemplate.definition.script.scripts[key].name, value: key });
        }
    });
    scriptSelect.options = options;
    var dynamicSettings = [];
    if (integrationResourceTemplate === null || integrationResourceTemplate === void 0 ? void 0 : integrationResourceTemplate.resources) {
        for (var group in integrationResourceTemplate.resources) {
            if ((_e = integrationResourceTemplate === null || integrationResourceTemplate === void 0 ? void 0 : integrationResourceTemplate.resources[group].dynamic) === null || _e === void 0 ? void 0 : _e.settings) {
                for (var i in (_f = integrationResourceTemplate === null || integrationResourceTemplate === void 0 ? void 0 : integrationResourceTemplate.resources[group].dynamic) === null || _f === void 0 ? void 0 : _f.settings) {
                    dynamicSettings.push((_g = integrationResourceTemplate === null || integrationResourceTemplate === void 0 ? void 0 : integrationResourceTemplate.resources[group].dynamic) === null || _g === void 0 ? void 0 : _g.settings[i]);
                }
            }
        }
    }
    var primaryColumnSettings = integrationResourceTemplate === null || integrationResourceTemplate === void 0 ? void 0 : integrationResourceTemplate.settings.filter(function (setting) {
        return setting.section !== "secondary" && setting.isVisible(props.resourceEditorData.variables);
    });
    var secondaryColumnSettings = integrationResourceTemplate === null || integrationResourceTemplate === void 0 ? void 0 : integrationResourceTemplate.settings.filter(function (setting) {
        return setting.section === "secondary" && setting.isVisible(props.resourceEditorData.variables);
    });
    return (react_1.default.createElement(material_1.Accordion, { expanded: props.expanded, onChange: props.onChange, sx: {
            borderRadius: "10px",
            boxShadow: "\n                    1px 1px 1px -1px rgba(0, 0, 0, 0.2),\n                    1px 1px 1px 0px rgba(0, 0, 0, 0.1),\n                    1px 1px 1px 0px rgba(0, 0, 0, 0.1)",
            width: "100%",
        } },
        react_1.default.createElement(material_1.AccordionSummary, { "data-cy": "integrationResourceAccordionHeader", expandIcon: react_1.default.createElement(ExpandMore_1.default, null), sx: {
                "&.Mui-expanded": {
                    backgroundColor: "var(--secondary-color)",
                    height: "48px",
                    minHeight: 0
                },
                backgroundColor: "#f9f8f8"
            } },
            react_1.default.createElement("div", { className: Integration_module_css_1.default["accordion-summary-container"], style: { display: "flex", justifyContent: "space-between", width: "100%" } },
                react_1.default.createElement("div", { style: { display: "flex", alignItems: "center" } },
                    integrationResourceTemplate && (react_1.default.createElement("div", { style: { paddingRight: "5px" } },
                        integrationResourceTemplate.name,
                        ":")),
                    react_1.default.createElement("div", { style: { color: "var(--info-color)" } }, (_h = props.resourceEditorData) === null || _h === void 0 ? void 0 : _h.name)))),
        react_1.default.createElement(material_1.AccordionDetails, null,
            react_1.default.createElement("div", { style: { display: "flex" } },
                react_1.default.createElement("div", { style: { width: "50%" } },
                    react_1.default.createElement(q_play_components_1.SettingsComponent, { key: scriptSelect.key, value: (_k = (_j = props.resourceEditorData) === null || _j === void 0 ? void 0 : _j.template) !== null && _k !== void 0 ? _k : "", disabled: false, setting: scriptSelect, onChange: onIntegrationScriptChange }),
                    react_1.default.createElement(q_play_components_1.SettingsComponent, { key: scriptName.key, value: (_m = (_l = props.resourceEditorData) === null || _l === void 0 ? void 0 : _l.name) !== null && _m !== void 0 ? _m : "", disabled: false, setting: scriptName, onChange: onScriptNameChange }), primaryColumnSettings === null || primaryColumnSettings === void 0 ? void 0 :
                    primaryColumnSettings.map(function (setting) {
                        var _a, _b, _c, _d;
                        return (react_1.default.createElement(q_play_components_1.SettingsComponent, { key: setting.key, value: (_c = (_b = (_a = props.resourceEditorData) === null || _a === void 0 ? void 0 : _a.variables) === null || _b === void 0 ? void 0 : _b[setting.key]) !== null && _c !== void 0 ? _c : "", disabled: dynamicSettings.indexOf(setting.key) > -1 || setting.isDisabled(((_d = props.resourceEditorData) === null || _d === void 0 ? void 0 : _d.variables) || {}), setting: setting, onChange: onScriptSettingsChangedHandler }));
                    })),
                react_1.default.createElement("div", { style: { width: "50%", marginLeft: "50px" } }, secondaryColumnSettings === null || secondaryColumnSettings === void 0 ? void 0 : secondaryColumnSettings.map(function (setting) {
                    var _a, _b, _c, _d;
                    return (react_1.default.createElement(q_play_components_1.SettingsComponent, { key: setting.key, value: (_c = (_b = (_a = props.resourceEditorData) === null || _a === void 0 ? void 0 : _a.variables) === null || _b === void 0 ? void 0 : _b[setting.key]) !== null && _c !== void 0 ? _c : "", disabled: dynamicSettings.indexOf(setting.key) > -1 || setting.isDisabled(((_d = props.resourceEditorData) === null || _d === void 0 ? void 0 : _d.variables) || {}), setting: setting, onChange: onScriptSettingsChangedHandler }));
                }))))));
};
exports.default = ResourceScriptAccordion;
